const DEFAULT_MAP_ZOOM = 16;

export default class PaQuickQuoteLocationMap {

    constructor({
        mapsApi, coords, getDeviceLocation, address, defaultLocation
    }) {
        this.canChangePos = false;
        this.mapsApi = mapsApi;
        this.coords = coords;
        this.getDeviceLocation = getDeviceLocation;
        this.address = address;
        this.defaultLocation = defaultLocation;
    }

    init(mountNode) {
        this.initMap(mountNode);
        this.setInitialMarkerPosition();
    }

    initMap(mountNode) {
        this.map = new this.mapsApi.Map(mountNode, {
            zoom: DEFAULT_MAP_ZOOM,
            center: this.getInitialMapCenter(),
            clickableIcons: false,
            streetViewControl: false,
            disableDoubleClickZoom: true,
            gestureHandling: 'cooperative',
            draggableCursor: 'pointer',
            disableDefaultUI: true
        });
        return new Promise((resolve) =>
            this.onceIdle(() => {
                this.mapsApi.event.trigger(this.map, 'resize');
                resolve();
            }));
    }

    onceIdle(action) {
        this.mapsApi.event.addListenerOnce(this.map, 'idle', action);
    }

    setInitialMarkerPosition() {
        if (this.areCoordsProvided()) {
            this.setMarkerPosition({lat: this.coords.latitude, lng: this.coords.longitude});
        } else {
            this.setDeviceGeolocation();
        }
    }

    initMarker() {
        this.marker = new this.mapsApi.Marker({
            map: this.map,
            draggable: false,
            animation: this.mapsApi.Animation.DROP,
            cursor: 'url(//maps.gstatic.com/mapfiles/openhand_8_8.cur) 8 8, default'
        });
    }

    setMarkerPosition(position) {
        this.coords.latitude = position.lat;
        this.coords.longitude = position.lng;
        if (!this.marker) {
            this.initMarker();
        }
        this.marker.setPosition(position);
    }

    areCoordsProvided() {
        return (this.coords && this.coords.latitude && this.coords.longitude);
    }

    getInitialMapCenter() {
        if (this.coords && this.coords.latitude && this.coords.longitude) {
            return {lat: this.coords.latitude, lng: this.coords.longitude};
        }
        return this.defaultLocation;
    }

    setDefaultLocation() {
        const defaultGeoLocation = this.defaultLocation;
        this.map.setCenter(defaultGeoLocation);
        this.setMarkerPosition(defaultGeoLocation);
        const position = {
            coords: {
                latitude: defaultGeoLocation.lat,
                longitude: defaultGeoLocation.lng
            }
        };
        this.getDeviceLocation({
            position: position
        });
    }

    setDeviceGeolocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const latLong = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.map.setCenter(latLong);
                this.setMarkerPosition(latLong);
                this.getDeviceLocation({
                    position: position
                });
            }, () => {
                this.setDefaultLocation();
            });
        } else {
            this.setDefaultLocation();
        }
    }
}